module.exports = __webpack_public_path__ + "static/media/Overhead-Pantograph.af3c12d1.svg";